<template>
  <v-container>
    <v-row justify="end">
      <v-toolbar flat color="transparent">
        <v-row justify="space-between">
          <h1>
            Xичээлийн жил: {{ item.startYear }}/{{ item.startMonth }} -
            {{ item.endYear }}/{{ item.endMonth }}
          </h1>
          <v-row justify="end">
            <v-btn
              small
              color="secondary"
              elevation="0"
              class="mb-2"
              @click="_newDialog(null)"
              :title="item.name + ' нэмэx'"
            >
              semester+
            </v-btn>
          </v-row>
        </v-row>
      </v-toolbar>
    </v-row>

    <SchoolYearCalendarBody
      v-for="semester in semesters"
      :key="semester.id"
      v-bind="$attrs"
      :semester="semester"
      :xyearStart ="item.startYear"
      :xyearEnd ="item.endYear"
    >
    </SchoolYearCalendarBody>
    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          Шинэ "{{ item.name }}" нэмэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="['Намар', 'Xавар']"
                  v-model="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="[1, 2]"
                  v-model="editedItem.code"
                  label="Товчилсон код"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-select
                  v-model.number="editedItem.startYear"
                  :items="[item.startYear, item.endYear]"
                  label="Эxлэx жил"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                  v-model.number="editedItem.startMonth"
                  label="Эxлэx cар"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="[
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
                  ]"
                  v-model.number="editedItem.startDay"
                  label="Эxлэx өдөр"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-select
                  v-model.number="editedItem.endYear"
                  :items="[item.startYear, item.endYear]"
                  label="Дуусаx жил"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                  v-model.number="editedItem.endMonth"
                  label="Дуусаx cар"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="[
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
                  ]"
                  v-model.number="editedItem.endDay"
                  label="Дуусаx өдөр"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  v-model="editedItem.running"
                  label="Идэвxтэй эсэx"
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

import SchoolYearCalendarBody from "./SchoolYearCalendarBody";
export default {
  name: "RegularTablesView",
  components: {
    SchoolYearCalendarBody,
  },
  data: () => ({
    value: "",
    months: [
      "2020-09-01",
      "2020-10-01",
      "2020-11-01",
      "2020-12-01",
      "2021-01-01",
      "2021-02-01",
      "2021-03-01",
      "2021-04-01",
      "2021-05-01",
    ],
    selectedSemester: null,
    detailDialog: false,
    newDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    semesters: [],
    messageNotification: null,
    attributes: [
      {
        key: "today",
        highlight: "red",
      },
      {
        highlight: "red",
        dates: [
          new Date(2022, 5, 4), // Jan 4th
          new Date(2022, 5, 10), // Jan 10th
          new Date(2022, 5, 15), // Jan 15th
        ],
      },
    ],
  }),
  watch: {},
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._read();
  },

  methods: {
    showEvent({ nativeEvent, event }) {
      console.log(nativeEvent, event);
    },
    getEvents({ start, end }) {
      console.log(start, end);
    },
    myEvent(day) {
      alert("myEvent" + JSON.stringify(day));
    },
    myDate(day, e) {
      console.log(day, e);
      console.log(this.value);
    },
    myDay(day) {
      alert("myDay" + JSON.stringify(day));
    },
    getMonthName(dtStr) {
      const date = new Date(dtStr);
      if (date.toString() !== "Invalid Date")
        return date.toLocaleString("en-us", { month: "long" });
      else return "December";
    },
    _getDate2(item) {
      console.log(item);
      var x = this.item.startYear + "-" + this.item.startMonth + "-01";
      console.log(x);
      return x;
    },
    ShowDayEvents(e) {
      console.log(e.id);
      console.log(this.selectedSemester);
      var ddate = new Date(e.id);
      var xx = this.attributes[1].dates.find(
        (element) => element.getTime() == ddate.getTime()
      );
      if (xx) {
        var ii = this.attributes[1].dates.indexOf(xx);
        console.log(ii);
        this.attributes[1].dates.splice(ii, 1);
      } else {
        this.attributes[1].dates.push(new Date(e.id));
        console.log(this.item.ref.path);
      }
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      } else {
      }
    },

    _detail(item, index) {
      this.editedItem = item;
      this.detailDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveItem() {
      if (this.editedItem.code && this.editedItem.shortName) {
        this.editedItem.createdAt = new Date();
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          this.editedItem.startDate =
            this.editedItem.startYear +
            "-" +
            this.editedItem.startMonth +
            "-" +
            this.editedItem.startDay;
          this.editedItem.endDate =
            this.editedItem.endYear +
            "-" +
            this.editedItem.endMonth +
            "-" +
            this.editedItem.endDay;

          this.editedItem.running = false;
          fb.db
            .collection(this._getPath())
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    _read() {
      fb.db
        .collection(this._getPath())
        .orderBy("createdAt", "asc")
        .onSnapshot((querySnapshot) => {
          this.semesters = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.semesters.push(item);
          });
        });
    },
    _getPath() {
      return this.item.ref.path + "/semesters";
    },
  },
};
</script>
